import React from 'react'
import { Box, Button, Clickable, Tooltip, Icon, InputGroup } from '@maui/elements'
import { BaseDropdown } from '@/components/forms/fields/BaseDropdown'

const DropdownItems = ({ children }) => {
  return (
    <>
      {React.Children.map(children, (child, i) =>
        <BaseDropdown.Item key={i} p='0'>{child}</BaseDropdown.Item>
      )}
    </>
  )
}
const DropdownButton = ({ children, ...props }) => {
  return (
    <Button
      aria-label='select'
      variant='text'
      width='100%'
      color='colorTextMain'
      p='spaceGapXLarge'
      {...props}
    >
      {children}
    </Button>
  )
}
const tooltipString = 'The "exclusive" column indicates an indicator that Mandiant Intelligence can explicitly attribute to a single threat actor. Indicators that have the possibility of being leveraged by multiple threat actors are not considered "exclusive", such as an IP address.'

export const indicatorTableColumnsWithThreatScore = [
  {
    Header: 'Indicator Value',
    accessor: 'value',
    width: 375,
    threatScoreView: true,
  },
  {
    Header: 'Type',
    Filter: ({
      column: {
        filterValue,
        setFilter
      }
    }) => {
      return (
        <BaseDropdown
          py='0'
          width='75px'
          backgroundColor='cInputBackgroundColor'
          trigger={() => (
            <BaseDropdown.Trigger
              height='28px'
              padding='0'
              borderStyle='none'
            >
              <InputGroup
                inputProps={{
                  readOnly: true,
                  value: filterValue?.toString().toUpperCase(),
                  cursor: 'pointer',
                  width: '100%',
                  height: '100%'
                }}
                onChange={e => setFilter(e.target.value)}
                slotRight={<ClearIcon value={filterValue?.toString()} eventHandler={setFilter} emptyValue={[]} />}
              />
            </BaseDropdown.Trigger>
          )}
        >
          <DropdownItems>
            <DropdownButton onClick={e => setFilter(['fqdn'])}>FQDN</DropdownButton>
            <DropdownButton onClick={e => setFilter(['ipv4'])}>IPV4</DropdownButton>
            <DropdownButton onClick={e => setFilter(['hash'])}>Hash</DropdownButton>
            <DropdownButton onClick={e => setFilter(['url'])}>URL</DropdownButton>
          </DropdownItems>
        </BaseDropdown>
      )
    },
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'Threat Score',
    accessor: 'threat_score',
    width: 100,
    disableFilters: true,
  },
  {
    Header: 'Associated Actors',
    accessor: 'actorAssociations',
    width: 250,
    disableSortBy: true
  },
  {
    Header: 'Associated Malware',
    accessor: 'malwareAssociations',
    width: 250,
    disableSortBy: true
  },
  {
    Header: 'Associated Tools',
    accessor: 'toolAssociations',
    width: 250,
    disableSortBy: true
  },
  {
    Header: 'Associated Campaigns',
    accessor: 'campaignAssociations',
    width: 250,
    disableSortBy: true
  },
  {
    Header: () => {
      return (
        <Box display='flex' gap='spaceGapSmall' >
          <Box>Exclusive</Box>
          <Tooltip tooltip={tooltipString}>
            <Icon name="info" verticalAlign="top" />
          </Tooltip>
        </Box>
      )
    },
    accessor: 'is_exclusive',
    width: 100,
    disableSortBy: true,
    disableFilters: true
  },
  {
    Header: 'First Seen',
    accessor: 'first_seen',
    disableFilters: true
  },
  {
    Header: 'Last Seen',
    accessor: 'last_seen',
    disableFilters: true
  },
]

export const indicatorTableColumns = [
  {
    Header: 'Indicator Value',
    accessor: 'value',
    width: 375,
  },
  {
    Header: 'Type',
    Filter: ({
      column: {
        filterValue,
        setFilter
      }
    }) => {
      return (
        <BaseDropdown
          py='0'
          width='75px'
          backgroundColor='cInputBackgroundColor'
          trigger={() => (
            <BaseDropdown.Trigger
              height='28px'
              padding='0'
              borderStyle='none'
            >
              <InputGroup
                inputProps={{
                  readOnly: true,
                  value: filterValue?.toString().toUpperCase(),
                  cursor: 'pointer',
                  width: '100%',
                  height: '100%'
                }}
                onChange={e => setFilter(e.target.value)}
                slotRight={<ClearIcon value={filterValue?.toString()} eventHandler={setFilter} emptyValue={[]} />}
              />
            </BaseDropdown.Trigger>
          )}
        >
          <DropdownItems>
            <DropdownButton onClick={e => setFilter(['fqdn'])}>FQDN</DropdownButton>
            <DropdownButton onClick={e => setFilter(['ipv4'])}>IPV4</DropdownButton>
            <DropdownButton onClick={e => setFilter(['hash'])}>Hash</DropdownButton>
            <DropdownButton onClick={e => setFilter(['url'])}>URL</DropdownButton>
          </DropdownItems>
        </BaseDropdown>
      )
    },
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'IC Score',
    accessor: 'mscore',
    width: 100,
    disableFilters: true
  },
  {
    Header: 'Associated Actors',
    accessor: 'actorAssociations',
    width: 175,
    disableSortBy: true
  },
  {
    Header: 'Associated Malware',
    accessor: 'malwareAssociations',
    width: 175,
    disableSortBy: true
  },
  {
    Header: 'Associated Tools',
    accessor: 'toolAssociations',
    width: 175,
    disableSortBy: true
  },
  {
    Header: 'Associated Campaigns',
    accessor: 'campaignAssociations',
    width: 185,
    disableSortBy: true
  },
  {
    Header: () => {
      return (
        <Box display='flex' gap='spaceGapSmall' >
          <Box>Exclusive</Box>
          <Tooltip tooltip={tooltipString}>
            <Icon name="info" verticalAlign="top" />
          </Tooltip>
        </Box>
      )
    },
    accessor: 'is_exclusive',
    width: 100,
    disableSortBy: true,
    disableFilters: true
  },
  {
    Header: 'First Seen',
    accessor: 'first_seen',
    disableFilters: true
  },
  {
    Header: 'Last Seen',
    accessor: 'last_seen',
    disableFilters: true
  },
]

export const ClearIcon = ({ value, eventHandler, emptyValue }) => {
  if (!value) {
    return null
  }
  return (
    <Clickable
      onClick={e => {
        e.stopPropagation()
        e.preventDefault()
        eventHandler(emptyValue)
      }}
      data-test='clear-icon'
    >
      <Icon name='times' />
    </Clickable>
  )
}
